import React from 'react';
import './Portafolio2.css';

const partnerLogos = [
  { src: '/images/logo-microsoft-partner.svg', alt: 'Microsoft Partner' },
  { src: '/images/logo-gfi-unlimited.svg', alt: 'GFI Unlimited' },
  { src: '/images/logo-veeam.svg', alt: 'Veeam' },
  { src: '/images/logo-sophos.svg', alt: 'Sophos' },
  { src: '/images/logo-dell.svg', alt: 'Dell' },
  { src: '/images/logo-vmware.svg', alt: 'VMware' },
  { src: '/images/logo-acronis-cloud.svg', alt: 'Acronis Cloud Backup' },
  { src: '/images/logo-avast.svg', alt: 'Avast' }
];

function PartnerShowcase() {
  return (
    <section className='partners-section'>
      <div className='partners-cta'>
        <h2>¿No estás seguro por dónde empezar? Hablemos de los problemas de TI de su empresa.</h2>
        <a className='cta-button' href='mailto:info@tekins.com'>Contáctanos</a>
      </div>

      <div className='partner-grid'>
        {partnerLogos.map((logo) => (
          <div key={logo.alt} className='partner-logo'>
            <img src={logo.src} alt={logo.alt} />
          </div>
        ))}
      </div>

      <div className='contact-block'>
        <h3>Contacte con nosotros</h3>
        <p className='contact-phones'>WhatsApp: +507 6643-5949 | Panamá: +507 391-4683 | Miami: (786) 605-0280</p>
        <a className='contact-mail' href='mailto:info@tekins.com'>info@tekins.com</a>
      </div>
    </section>
  );
}

export default PartnerShowcase;
